import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Card, Col, Row, Flex } from 'antd';
import DiagramNode from './DiagramNode';
import Title from './Title';

const Diagram = (props) => {
  return (
    <>
      <Title label={props.title}></Title>
      <Row>
        <Flex>
          {props.nodes.map((node, index) => {
            return (
              <>
                <Col span={4}>
                  <DiagramNode
                    title={node.title}
                    description={node.description}
                    icon={node.icon}
                    isHome={true}
                  />
                </Col>
              </>
            );
          })}
        </Flex>
      </Row>
    </>
  );
};

export default Diagram;
